import * as React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

function SvgDeleteIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#1E1E1E"
          stroke="null"
          d="M14.3366297,2.5126052 L9.6070199,2.5126052 L9.6070199,5.32907052e-15 L4.7296098,5.32907052e-15 L4.7296098,2.54216527 L7.91366972e-13,2.54216527 L7.91366972e-13,4.02016833 L1.71448355,4.02016833 L2.09876435,16.3467139 L12.2378653,16.3467139 L12.6221461,4.02016833 L14.3366297,4.02016833 L14.3366297,2.5126052 L14.3366297,2.5126052 Z M10.8485425,12.6517062 L9.78438027,13.6863083 L7.242215,11.1441431 L4.7296098,13.6863083 L3.69500765,12.6517062 L6.23717292,10.1095409 L3.69500765,7.56737567 L4.7296098,6.53277353 L7.27177506,9.0749388 L9.81394033,6.53277353 L10.8485425,7.56737567 L8.3063772,10.1095409 L10.8485425,12.6517062 Z M6.20761286,1.47800306 L8.09945678,1.47800306 L8.09945678,2.54216527 L6.20761286,2.54216527 L6.20761286,1.47800306 L6.20761286,1.47800306 Z"
          id="Shape"
        />
      </g>
    </SvgIcon>
  );
}

export default SvgDeleteIcon;
